<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100">
      <md-card>
        <md-card-header class="md-card-header-icon md-card-header-blue">
          <graph-tool-bar></graph-tool-bar>
        </md-card-header>

        <md-card-content>
          <highcharts class="charts" :options="chartOptions" ref="areaChart"></highcharts>
        </md-card-content>
      </md-card>
    </div>

    <snack-bar ref="snackbar"></snack-bar>
  </div>
</template>


<script>
import graphToolBar from "@/components/GraphToolBar";
import areaChartOptions from "@/config/charts/area";
import axios from "axios";
import { getSelectedDeviceToken } from "@/storage/memoryStorage";
import snackBar from "@/components/SnackBar";

export default {
  components: {
    "graph-tool-bar": graphToolBar,
    "snack-bar": snackBar
  },
  data() {
    return {
      chartOptions: null,
      selectedPhaseLocal: null,
      chartLines: {
        L1: [],
        L2: [],
        L3: []
      },
      phases: ["L1", "L2", "L3"]
    };
  },
  computed: {
    selectedDate() {
      return this.$store.getters.getDateRange;
    },
    selectedDevice() {
      return this.$store.getters.getSelectedDevice;
    },
    selectedPhase() {
      return this.$store.getters.getSettings.phase;
    },
    selectedyAxisType() {
      return this.$store.getters.getSettings.yAxisType;
    }
  },
  watch: {
    selectedDate: function(newDate, oldDate) {
      if (newDate.from !== oldDate.from || newDate.to !== oldDate.to) {
        this.getAPIData(this.selectedDate.from, this.selectedDate.to);
      }
    },
    selectedDevice: function(newDevice, oldDevice) {
      if (newDevice.mac !== oldDevice.mac) {
        this.getAPIData(this.selectedDate.from, this.selectedDate.to);
      }
    }
  },
  created() {
    const onyAxisSelect = type => {
      this.$store.commit("setyAxisType", type);
    };

    this.chartOptions = JSON.parse(JSON.stringify(areaChartOptions));
    this.chartOptions.title.text = this.$lang.charts.active_power_profile_with_appliances;
    this.chartOptions.yAxis.labels.format = "{value} W";
    this.chartOptions.tooltip.pointFormat =
      "<span style='color:{point.color}'>●</span> {series.name}: <b>{point.y} W</b><br/>";
    /*     this.chartOptions.series = [
      {
        name: this.$lang.charts.phase + " L1",
        type: "area",
        visible: this.selectedPhase.L1,
        marker: {
          enabled: false
        },
        events: {
          legendItemClick: function(event) {
            onPhaseSelect("L1", event.target.visible);
          }.bind(this)
        },
        dashStyle: "Solid",
        data: []
      },
      {
        name: this.$lang.charts.phase + " L2",
        type: "area",
        visible: this.selectedPhase.L2,
        marker: {
          enabled: false
        },
        events: {
          legendItemClick: function(event) {
            onPhaseSelect("L2", event.target.visible);
          }.bind(this)
        },
        data: []
      },
      {
        name: this.$lang.charts.phase + " L3",
        type: "area",
        visible: this.selectedPhase.L3,
        marker: {
          enabled: false
        },
        events: {
          legendItemClick: function(event) {
            onPhaseSelect("L3", event.target.visible);
          }.bind(this)
        },
        data: []
      }
    ]; */
    this.chartOptions.yAxis.type = this.selectedyAxisType;
    this.chartOptions.chart.events = {
      redraw: function(event) {
        this.hideLoading();
      }
    };
    this.chartOptions.exporting.buttons.contextButton.menuItems.push(
      "separator"
    );

    this.chartOptions.exporting.buttons.contextButton.menuItems.push({
      textKey: "scalerChange",
      onclick: function() {
        if (this.userOptions.yAxis.type == "logarithmic") {
          this.userOptions.yAxis.type = "linear";
          this.yAxis[0].update({ type: "linear" });
          onyAxisSelect("linear");
        } else {
          this.userOptions.yAxis.type = "logarithmic";
          this.yAxis[0].update({ type: "logarithmic" });
          onyAxisSelect("logarithmic");
        }
      }
    });
  },

  mounted() {
    this.getAPIData(this.selectedDate.from, this.selectedDate.to);
  },

  methods: {
    getAPIData(apiFrom, apiTo) {
      const { chart } = this.$refs.areaChart;
      chart.showLoading();

      const onPhaseSelect = (phase, visibility) => {
        this.selectedPhaseLocal = this.selectedPhase;
        this.selectedPhaseLocal[phase] = !visibility;
        this.$store.commit("setSelectedPhase", this.selectedPhaseLocal);

        const { chart } = this.$refs.areaChart;

        this.chartLines[phase].forEach(element => {
          if (visibility === false) {
            chart.xAxis[0].addPlotLine(element);
          } else {
            chart.xAxis[0].removePlotLine(element.id);
          }
        });
      };

      for (let i = 1; i <= 3; i++) {
        if (this.chartLines["L" + i]) {
          this.chartLines["L" + i].forEach(element => {
            chart.xAxis[0].removePlotLine(element.id);
          });
        }

        this.chartLines["L" + i] = [];
      }
      this.chartOptions.series = [];

      for (let i = 0; i < this.selectedDevice.phase_use; i++) {
        this.chartOptions.series.push({
          name: this.$lang.charts.phase + " " + this.phases[i],
          type: "area",
          visible: this.selectedPhase[this.phases[i]],
          marker: {
            enabled: false
          },
          events: {
            legendItemClick: function(event) {
              onPhaseSelect(this.phases[i], event.target.visible);
            }.bind(this)
          },
          data: []
        });
      }

      axios({
        method: "POST",
        url: this.$ENDPOINTS.API_R + "/nilm/runtime",
        data: {
          token: getSelectedDeviceToken(this.selectedDevice.mac),
          phase: "L1,L2,L3",
          from: apiFrom,
          to: apiTo,
          microseconds: true
        },
        withCredentials: true
      })
        .then(response => {
          response.data.data.forEach(el => {
            this.chartLines[el.phase].push({
              id: el.ID_appliance + el.start,
              label: {
                text: el.name + " (START)"
              },
              value: el.start,
              width: 2,
              color: "rgba(68, 170, 213, .2)"
            });

            if (el.duration > 0) {
              this.chartLines[el.phase].push({
                id: el.phase,
                label: {
                  text: el.name + " (END)"
                },
                value: el.end,
                width: 2,
                color: "rgba(68, 170, 213, .2)"
              });
            }
          });

          for (let i = 1; i <= 3; i++) {
            if (this.selectedPhase["L" + i] === true) {
              this.chartLines["L" + i].forEach(element => {
                chart.xAxis[0].addPlotLine(element);
              });
            }
          }
        })
        .catch(error => {
          if (error.response.data.code == 610) {
            //this.$refs.snackbar.notify(this.$lang.messages.data_not_found);
            //chart.series[0].setData([]);
          } else {
            this.$refs.snackbar.notify(
              this.$lang.messages.api_communication_error
            );
          }
        });

      axios({
        method: "POST",
        url: this.$ENDPOINTS.API_R + "/profile",
        data: {
          token: getSelectedDeviceToken(this.selectedDevice.mac),
          data: "P",
          phase: "L1,L2,L3",
          from: apiFrom,
          to: apiTo,
          cumulative: true,
          format: "H"
        },
        withCredentials: true
      })
        .then(response => {
          if (response.data.status === "OK") {
            for (let i = 0; i < this.selectedDevice.phase_use; i++) {
              chart.series[i].setData(
                response.data.data.P[this.phases[i]],
                false,
                false,
                false
              );
            }

            chart.xAxis[0].setExtremes(null, null, true);
          } else {
            this.$refs.snackbar.notify(
              this.$lang.messages.api_communication_error
            );
          }
        })
        .catch(error => {
          if (error.response) {
            if (error.response.data.code == 610) {
              this.$refs.snackbar.notify(this.$lang.messages.data_not_found);
              for (let i = 0; i < this.selectedDevice.phase_use; i++) {
                chart.series[i].setData([]);
              }
            } else {
              this.$refs.snackbar.notify(
                this.$lang.messages.api_communication_error
              );
            }
          }
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.md-layout {
  margin-top: -29px;
}
</style>